import { KeyValuePipe } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { SkSpinner3Component } from '@rocksoft/cdk';
import { MdmCommand } from '@rocksoft/mdm-sdk-v2';
import { TimelineCommandComponent } from './timeline.command.component';

@Component({
  selector: 'ml-timeline-command',
  templateUrl: './timeline.command.container.html',
  styleUrls: ['./timeline.command.container.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TimelineCommandComponent, SkSpinner3Component, KeyValuePipe],
})
export class TimelineCommandContainerComponent {
  readonly commandContent = input.required<MdmCommand>();
}
